
<Detail :enable-popup-alert="false">
    <template v-slot:content>
        <h1>404 <small>Not Found</small></h1>
        <small class="text-muted">SOURCE <strong>{{ $route.fullPath }}</strong> NOT FOUND</small>
    </template>
</Detail>
